import React, { useEffect, useState } from 'react';
import { chatService } from 'services/chat.service';

const useChatList = (payload = { skip: 0, limit: 5 }, msgList) => {
    const [chatList, setChatList] = useState({});

    const handleApi = async () => {
        try {
            const response = await chatService.getChatsList(payload);
            setChatList(response.data.data)
        } catch (err) {
            console.log(err)
        }
    }

    useEffect(() => {
        handleApi();
    }, [payload?.limit, msgList]);

    return { chatList };
}

export default useChatList